import React from "react";
import "./OutletDetails.css";
import { Divider, Tooltip } from "@mui/material";
import { truncateText } from "../../stocks/RealTimeStock/RealTimeStockUtils";
import { ViewOutletDetailsData } from "../../../types/types";

type ViewOutletDetailsDataKeys = keyof ViewOutletDetailsData;

export type OutletDetailsMetaDataItem = {
  key: keyof ViewOutletDetailsData;
  bottomKey?: keyof ViewOutletDetailsData;
  label: string;
  truncateTextAfterChar?: number;
  removeKey?: boolean;
};

interface OutletDetailsDataProps {
  outletData?: ViewOutletDetailsData
  heading: string;
  outletDetails?: OutletDetailsMetaDataItem[][];
}

const OutletDetailsData: React.FC<OutletDetailsDataProps> = ({
  outletData,
  heading,
  outletDetails = [],
}) => {
  return (
    <div className="outlet_details_data_container">
      <div className="outlet_details_data_header">
        <div className="outlet_details_data_heading">{heading}</div>
      </div>

      <div className="outlet_details_data">
        {outletDetails.map((column, colIndex) => (
          <>
            <div className="outlet_details_data_column" key={colIndex}>
              {column.map((item) => {
                const rawValue = outletData?.[item.key];
                const bottomRawValue = item.bottomKey ? outletData?.[item.bottomKey] : undefined;

                const displayValue =
                  rawValue === null || rawValue === undefined || rawValue === "" ? "-" : rawValue.toString();

                const bottomValue =
                  bottomRawValue === null || bottomRawValue === undefined || bottomRawValue === "" ? "" : bottomRawValue.toString();

                const combinedDisplay = bottomValue ? `${displayValue} (${bottomValue})` : displayValue;
                const tooltipText = bottomValue ? `${displayValue}\n${bottomValue}` : displayValue;

                const removeKey = item.removeKey ?? false;
                if (removeKey) return null;

                return (
                  <div className="outlet_details_data_row" key={item.key}>
                    <span className="outlet_details_data_row_label">{item.label}</span>
                    <Tooltip title={<div>{displayValue}<br />{bottomValue}</div>} arrow>
                      <span className="outlet_details_data_row_value">
                        {item.truncateTextAfterChar
                          ? truncateText(combinedDisplay, item.truncateTextAfterChar)
                          : combinedDisplay}
                      </span>
                    </Tooltip>
                  </div>
                );
              })}
            </div>
            {colIndex < outletDetails.length - 1 && (
              <Divider
                style={{
                  padding: "10px 0",
                  borderRight: "2px dotted",
                  color: "#DFE2E7",
                  margin: "0 20px",
                  boxSizing: "border-box",
                }}
                orientation="vertical"
                flexItem
              />
            )}
          </>
        ))}
      </div>
    </div>
  );
};

export default OutletDetailsData;
